import { useOutletContext } from 'react-router-dom';

import { DodOutletContext } from '../../Dod.types';

/**
 * Typed accessor for what the DOD layout route passes down to a tab.
 *
 * Tabs get their time range and filters from `useDodFilters()` (the URL), not from here — this
 * context carries only what the shell owns: the live socket, the capability probe and the
 * manual-refresh signal.
 */
export const useDodOutlet = (): DodOutletContext => useOutletContext<DodOutletContext>();
